import React from 'react';

import AlmeMinimize from '../AlmeMinimize/AlmeMinimize';
import AlmeClose from '../AlmeClose/AlmeClose';
import headerStyles from './AlmeHeader.styles';
import AlmeMoreMenu from '../AlmeMoreMenu/AlmeMoreMenu';

import { makeStyles, createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { FocusComponentProps } from '../../models/ComponentProps';
import { AlmeHeaderConfig } from './AlmeHeaderConfig';
import AlmeUtilityBar from "../AlmeUtilityBar/AlmeUtilityBar";
import { AlmeIvaTypeProp } from '../../models/AlmeIvaTypeMapping';

import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(() =>
    createStyles({
        headerContainer: {
            display: 'flex',
            flexFlow: 'column nowrap',
        },
        headerRowContainer: {
            display: 'flex',
            flexFlow: 'row nowrap',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        titleContainer: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
        },
        buttonContainer: {
            display: 'flex',
        },
    }),
);

interface AlmeHeaderProps extends WithStyles<typeof headerStyles> {
    almeConfig: AlmeHeaderConfig;
    onMinimizeClick: () => void;
    onUtilityLinkClick: () => void;
    onResetIva: (isOpen: boolean, sessionEndReason: string, shouldResetIsInitialized?: boolean) => void;
    setIsDialogOpen: (isOpen: boolean) => void;
    ivaType?: AlmeIvaTypeProp;
    focusProps?: FocusComponentProps;
    isDialogOpen?: boolean;
    isLiveChatConnected?: boolean;
}

const AlmeHeader: React.FC<AlmeHeaderProps> = (props: AlmeHeaderProps) => {
    const classes = useStyles();

    let headerClasses = `${classes.headerContainer} ${props.classes.root}`;
    if (props.almeConfig.header.styles.hasBorder) {
        headerClasses += ` ${props.classes.divider}`;
    }

    const padClass = props.almeConfig.header.headerIcon ? props.classes.padTitle : '';
    const titleClassName = `${props.classes.text} ${padClass}`;

    const headerText = props.isLiveChatConnected ? 'header.liveChatHeaderText' : "header.headerText";
    return (
        <div id='alme-header-container' className={headerClasses} style={{ display: 'block' }}>
            <AlmeUtilityBar almeConfig={props.almeConfig.header} focusProps={props.focusProps} onUtilityLinkClick={props.onUtilityLinkClick}
                color={props.almeConfig.header.utilityBar.styles.backgroundColor} borderColor={props.almeConfig.header.utilityBar.styles.borderColor}
            />
            <div id='alme-header-row-container' className={classes.headerRowContainer}>
                <div className={classes.titleContainer}>
                    {props.almeConfig.header.headerIcon}
                    <Typography className={titleClassName} variant={props.almeConfig.header.styles.headerTextFont || "subtitle1"}
                        style={{ whiteSpace: 'pre-wrap' }}
                    >
                        <FormattedMessage
                            id={headerText}
                            defaultMessage="Default IVA Header"
                            description="Header text element" />
                    </Typography>
                </div>
                <div className={classes.buttonContainer}>
                    <AlmeMoreMenu almeConfig={props.almeConfig.header} focusProps={props.focusProps} ></AlmeMoreMenu>
                    <AlmeMinimize almeConfig={props.almeConfig.header} onMinimizeClick={props.onMinimizeClick}
                        focusProps={props.focusProps} />
                    <AlmeClose almeConfig={props.almeConfig.header} onResetIva={props.onResetIva} setIsDialogOpen={props.setIsDialogOpen}
                        focusProps={props.focusProps} isDialogOpen={props.isDialogOpen} />
                </div>
            </div>
        </div>
    );
};

export default withStyles(headerStyles)(AlmeHeader);
